import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
// Removed Ant Design imports
// Removed Text import
import reduce from 'lodash/reduce'
import set from 'lodash/set'
import React from 'react'
import { Link } from 'react-router-dom'
// Removed Layout, Collapse, Steps destructuring

import { API } from 'aws-amplify'
import { useLocalization } from 'localization'
import moment from 'moment'
import momentTz from 'moment-timezone'
import MediaQuery from 'react-responsive'
import { useNavigate } from 'react-router-dom'
import SEO from '../../../components/SEO'
import { ReactComponent as Up } from '../../../images/svg/arrow-up-chevron.svg'
import { ReactComponent as CalendarIcon } from '../../../images/svg/calendar-event-date.svg'
import { ReactComponent as GoogleLogo } from '../../../images/svg/google-logo.svg'
import { ReactComponent as NewSync } from '../../../images/svg/new-sync.svg'
import { ReactComponent as Close } from '../../../images/svg/x-close.svg'
import { useGlobalState } from '../../../store'
import { colorApple, colorOutlook } from '../../../utils/colors'
import { faApple, faOutlook } from '../../../utils/customIcons'
import { syncTypeText } from '../../../utils/words'
// Added CB component imports
import { Accordion } from '../../core/components/Accordion';
import { CBSelect } from '../../core/components/CBSelect';
import { CBTag } from '../../core/components/CBTag';
import {
  CBButton,
  CBCheckItem,
  CBColorPicker,
  CBHeader,
  CBInput,
  CBModal,
  CBRadioGroupBigCalendar,
  CBStep,
  CBSteps,
  SubmitButton,
  CBAlert // Added CBAlert
} from '../../core/components/cbd'
import SyncItem from '../components/SyncItem'


const CBSampleEvent = ({ policy, destType, tag, color }) => {
  // Simplified styling, removed direct color mapping for brevity
  const tagDisplay = tag === ' ' ? '' : tag; // Handle empty tag case
  return (
    <div className="flex p-2 border-2 border-neutral_4 m-2 rounded-sm">
      <div className="mr-2 flex-shrink-0">
        {color && (
          <CBColorPicker
            color={color}
            preview={true}
            type={destType}
          />
        )}
      </div>
      <div className="text-xs overflow-hidden"> {/* Added overflow hidden */}
        <div className="font-bold truncate"> {/* Added truncate */}
          {policy.includes('time') ? 'Free/Busy' : 'Subject'} {tagDisplay}
        </div>
        {policy.includes('location') && <div className="truncate">Meeting Location</div>}
        {destType == 'google' && policy.includes('meeting') && (
          <div className="truncate">Online Meeting</div>
        )}
        <div className="text-gray-600 mt-1">Event Content</div>
        <div className="m-1 border border-neutral_1 p-1 text-gray-500"> {/* Simplified border */}
          {policy.includes('description') && <div className="truncate">Body Text...</div>}
          {policy.includes('contact') && (
            <div className="truncate">
              Attendees: - Attendee Name - attendee-email@email.com - status ===
            </div>
          )}
          {destType == 'ms' && policy.includes('meeting') && (
            <div className="truncate">Online Meeting</div>
          )}
          {policy.includes('reminder') && <span className="mr-1">Reminder</span>} {/* Simplified */}
          {policy.includes('private') && <span>Private</span>} {/* Simplified */}
        </div>
      </div>
    </div>
  )
}
class SyncCreatePage extends React.Component {
  state = {
    showICS: false,
    ics_link: '',
    showModal: false,
    showAdvanced: true, // Keep advanced open by default based on original logic
    timeRangeActive: false,
    page: 0,
    lastPage: 2, // Adjusted based on removed DirectionForm step
    farthestPage: 0,
    allCalendars: [],
    sourceCalendarTimezone: momentTz.tz.guess(),
    destCalendarTimezone: momentTz.tz.guess(),
    sync: {
      source: null,
      destination: null,
      bidirection: false, // Defaulting to false as DirectionForm is removed
      includeTag: true,
      includeSubject: false,
      includeDescription: false,
      includeLocation: false,
      includeReminders: false,
      fullSync: false,
      sourceColor: 'default',
      destColor: 'default',
      label: '(copy)',
      matchColors: false,
      hasFilters: false,
      syncLevel: ['free', 'tentative', 'busy', 'oof', 'workingElsewhere'],
      filterColor: 'none',
      startCutOff: -1,
      endCutOff: -1,
      excludeInvites: false,
    },
    isLoading: false,
    error: null, // Added error state
    currentDate: moment(), // Added for timezone options
  }

  // Modified to return label/value objects for CBSelect
  getOptions() {
    return moment.tz.names().map((tz) => ({
      label: `${tz} (${moment.tz(this.state.currentDate, tz).format('Z z')})`,
      value: tz
    }));
  }

  componentDidMount() {
    this.setCalendarsFromProps()
  }

  componentDidUpdate(prevProps) {
    if (this.props.accounts.length !== prevProps.accounts.length) {
      this.setCalendarsFromProps()
    }
  }

   transformUrl(encodedUrl) {
    let decodedUrl = decodeURIComponent(encodedUrl);
    var split = decodedUrl.split('___')
    let base = split[0]
    let fragment = split[1]
    let url = new URL(base);
    let encodedParams = url.searchParams.toString();
    let finalUrl = `${url.origin}${url.pathname}?${encodedParams}#${fragment}`;
    return finalUrl;
 }

  loadExistingSync() {
    if (this.props.id) {
      var id = decodeURIComponent(this.props.id).replace('___', '#')
      if(id.startsWith("http") && id.includes("?")) {
        id = this.transformUrl(this.props.id)
      }
      const existingSync = this.props.syncs.find((s) => s.id === id); // Use find for single item

      if (!existingSync) {
          console.error("Existing sync not found:", id);
          // Handle error, maybe navigate away or show message
          return;
      }

      var calendars = this.props.accounts.reduce(
        (all, a) => [...all, ...a.calendars.map(c => ({...c, email: a.email}))], // Add email to calendar object
        []
      )

      var sourceIndex = -1;
      var sourceLabel = null;
      var sourceCal = null; // Store the actual calendar object
      for (var i = 0; i < calendars.length; i++) {
        var cal = calendars[i]
        if (
          cal.id == existingSync.sourceCalendarId &&
          cal.calendarAccountId == existingSync.sourceCalendarAccountId
        ) {
          sourceIndex = i
          sourceCal = cal; // Store the object
          sourceLabel = `${cal.name || cal.summary} - ${cal.email}` // Use email from enriched calendar object
          break
        }
      }

      var destIndex = -1;
      var destLabel = null;
      var destCal = null; // Store the actual calendar object
      for (var i = 0; i < calendars.length; i++) {
        var cal = calendars[i]
        if (
          cal.id == existingSync.destCalendarId &&
          cal.calendarAccountId == existingSync.destCalendarAccountId
        ) {
          destIndex = i
          destCal = cal; // Store the object
          destLabel = `${cal.name || cal.summary} - ${cal.email}` // Use email from enriched calendar object
          break
        }
      }

      var ifIcs = {};
      if (existingSync.sourceCalendarType == "ics") {
          ifIcs = {
            summary: "ICS Link",
            calendarAccountId: existingSync.sourceCalendarAccountId,
            id: existingSync.sourceCalendarId,
            calendarAccountType: "ics",
            timeZone: existingSync.sourceCalendarTimezone,
            canEdit: false, // ICS is read-only
            email: 'N/A' // Add placeholder email
          };
          sourceCal = ifIcs; // Use the ICS object as sourceCal
          sourceLabel = "ICS Link";
      }

      if ((!destCal || !sourceCal) && existingSync.sourceCalendarType !== "ics") {
        alert("Source or destination calendar is missing please delete sync and recreate")
      } else {
        var tag = existingSync.tag == 'default' ? '(copy)' : existingSync.tag
        if (
          existingSync.securityPolicy.includes('time') &&
          !existingSync.securityPolicy.includes('tag') &&
          !existingSync.securityPolicy.includes('subject')
        ) {
          tag = ' '
        }

        var newState = {
          originalSyncId: existingSync.id,
          orginalTwoWay: existingSync.twoWay, // Typo in original state? Keep for now.
          sourceCalendarTimezone: existingSync.sourceCalendarTimezone || momentTz.tz.guess(), // Add fallback
          destCalendarTimezone: existingSync.destCalendarTimezone || momentTz.tz.guess(), // Add fallback
          sourceLabel,
          destLabel,
          showAdvanced: true, // Keep advanced open
          sync: {
            ...this.state.sync, // Keep defaults for fields not in existingSync
            source: sourceCal, // Use the calendar object
            destination: destCal, // Use the calendar object
            label: tag,
            bidirection: existingSync.twoWay, // Set bidirection based on existing
            includeTag: existingSync.securityPolicy.includes('tag'),
            includeSubject: existingSync.securityPolicy.includes('subject'),
            includeDescription: existingSync.securityPolicy.includes('description'),
            includeLocation: existingSync.securityPolicy.includes('location'),
            includeReminders: existingSync.securityPolicy.includes('reminder'),
            includeMeeting: existingSync.securityPolicy.includes('meeting'),
            includeAttendees: existingSync.securityPolicy.includes('contact'),
            allPrivate: existingSync.securityPolicy.includes('private'),
            sourceColor: existingSync.sourceColor || 'default', // Add fallback
            destColor: existingSync.destinationColor || 'default', // Add fallback
            fullSync: false, // Assuming this isn't stored/needed for edit
            editBidirection: existingSync.twoWay, // Keep track if it was originally two-way
            matchColors: existingSync.matchColors == true,
            hasFilters: existingSync.hasFilters == true,
            filterColor: existingSync.filterColor || 'none', // Add fallback
            syncLevel: existingSync.syncLevel
              ? existingSync.syncLevel == 'all'
                ? ['free', 'tentative', 'busy', 'oof', 'workingElsewhere']
                : existingSync.syncLevel.split('|')
              : ['free', 'busy'], // Default if missing
            excludeInvites: existingSync.excludeInvites || false, // Add fallback
            // Cutoff times might need loading if stored
            startCutOff: existingSync.startCutOff !== undefined ? existingSync.startCutOff : -1,
            endCutOff: existingSync.endCutOff !== undefined ? existingSync.endCutOff : -1,
          },
        }
        this.setState(
          newState,
          () => {
            this.setState(
              { page: 1 }, // Start on page 1 (options) when editing
              () => { window.scrollTo(0, 0) }
            )
          }
        )
      }
    }
  }

  setCalendarsFromProps() {
    this.setState(
      {
        allCalendars: this.props.accounts.reduce(
          (all, a) => [...all, ...a.calendars.map(c => ({...c, email: a.email}))], // Add email to calendar object
          []
        ),
      },
      () => {
        this.loadExistingSync()
      }
    )
  }

  submitSync = async () => {
    this.setState({ error: null, isLoading: true }); // Set loading true

    const {
      source, destination, bidirection, includeTag, includeSubject,
      includeDescription, includeLocation, includeReminders, fullSync,
      allPrivate, sourceColor, destColor, label, includeMeeting,
      includeAttendees, matchColors, hasFilters, syncLevel, filterColor,
      startCutOff, endCutOff, excludeInvites
    } = this.state.sync;
    const { sourceCalendarTimezone, destCalendarTimezone, originalSyncId, orginalTwoWay } = this.state;

    if (!source || !destination) {
        this.setState({ isLoading: false, error: "Source or Destination calendar missing." });
        return;
    }

    var fixLabel = label
    if (
      fixLabel != ' ' &&
      fixLabel != '  ' &&
      fixLabel != '' &&
      fixLabel != 'default'
    ) {
      if (
        fixLabel.startsWith('{') ||
        fixLabel.startsWith('[') ||
        fixLabel.startsWith('(') ||
        fixLabel.endsWith(')')
      ) {
      } else {
        fixLabel = '(' + fixLabel + ')'
      }
    }


    const sourceCal = source;
    const destCal = destination;

    try {
      await API.post('bridge', '/bridge', {
        body: {
          originalSyncId: originalSyncId || '',
          originalTwoWay: orginalTwoWay || false,
          sourceCalendarId: sourceCal.id,
          sourceCalendarDisplayName: sourceCal.name || sourceCal.summary,
          sourceCalendarType: sourceCal.calendarAccountType,
          sourceCalendarAccountId: sourceCal.calendarAccountId,
          sourceCalendarTimezone: sourceCal.timeZone || sourceCalendarTimezone,
          destCalendarId: destCal.id,
          destCalendarDisplayName: destCal.name || destCal.summary,
          destCalendarType: destCal.calendarAccountType,
          destCalendarTimezone: destCal.timeZone || destCalendarTimezone,
          destCalendarAccountId: destCal.calendarAccountId,
          policy:
            (includeSubject ? 'subject' : 'time') +
            (includeTag && fixLabel !== ' ' ? '|tag' : '') + // Only include tag if not explicitly empty
            (includeDescription ? '|description' : '') +
            (includeLocation ? '|location' : '') +
            (includeReminders ? '|reminder' : '') +
            (allPrivate ? '|private' : '') +
            (includeMeeting ? '|meeting' : '') +
            (includeAttendees ? '|contact' : ''),
          twoWay: bidirection,
          canEditSource: sourceCal.canEdit,
          fullSync: fullSync, // This seems unused based on UI? Defaulting to false.
          sourceColor: sourceColor || 'default',
          destColor: destColor || 'default',
          label: fixLabel || 'default', // Use fixLabel
          matchColors: matchColors,
          hasFilters: hasFilters,
          syncLevel: syncLevel.join('|'),
          filterColor: filterColor || 'none',
          startCutOff: startCutOff,
          endCutOff: endCutOff,
          excludeInvites: excludeInvites,
        },
      });

      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'dashboardEvent',
        category: 'userActivity',
        action: originalSyncId ? 'updateSync' : 'createSync', // Differentiate action
        label: this.props.license.userId,
        email: this.props.license.email,
      });

      window.location.href = window.location.origin + '/dashboard/syncs/';
    } catch (ex) {
      console.error("Sync submission failed:", ex);
      this.setState({ isLoading: false, error: ex.response?.data?.message || 'Failed to save sync.' });
    }
  }

  buildSyncItemForPreview = () => {
    const {
      source, destination, bidirection, includeTag, includeSubject,
      includeDescription, includeLocation, includeReminders, fullSync,
      allPrivate, sourceColor, destColor, label, includeMeeting,
      includeAttendees, matchColors, hasFilters, syncLevel, filterColor,
      startCutOff, endCutOff, excludeInvites
    } = this.state.sync;
     const { sourceCalendarTimezone, destCalendarTimezone, originalSyncId, orginalTwoWay } = this.state;
    console.log(this.state.sync)

    if (!source || !destination) return null; // Cannot preview without calendars

    const sourceCal = source;
    const destCal = destination;
    var fixLabel = label
    if (
      fixLabel != ' ' &&
      fixLabel != '  ' &&
      fixLabel != '' &&
      fixLabel != 'default'
    ) {
      if (
        fixLabel.startsWith('{') ||
        fixLabel.startsWith('[') ||
        fixLabel.startsWith('(') ||
        fixLabel.endsWith(')')
      ) {
      } else {
        fixLabel = '(' + fixLabel + ')'
      }
    }


    const item = {
      id: originalSyncId || 'preview-id', // Use original ID or placeholder
      originalTwoWay: orginalTwoWay || false,
      sourceCalendarId: sourceCal.id,
      sourceCalendarName: sourceCal.name || sourceCal.summary,
      sourceCalendarType: sourceCal.calendarAccountType,
      sourceCalendarAccountId: sourceCal.calendarAccountId,
      sourceCalendarTimezone: sourceCal.timeZone || sourceCalendarTimezone,
      destCalendarId: destCal.id,
      destCalendarName: destCal.name || destCal.summary,
      destCalendarType: destCal.calendarAccountType,
      destCalendarTimezone: destCal.timeZone || destCalendarTimezone,
      destCalendarAccountId: destCal.calendarAccountId,
      securityPolicy:
        (includeSubject ? 'subject' : 'time') +
        (includeTag && fixLabel !== ' ' ? '|tag' : '') +
        (includeDescription ? '|description' : '') +
        (includeLocation ? '|location' : '') +
        (includeReminders ? '|reminder' : '') +
        (allPrivate ? '|private' : '') +
        (includeMeeting ? '|meeting' : '') +
        (includeAttendees ? '|contact' : ''),
      twoWay: bidirection,
      canEditSource: sourceCal.canEdit,
      fullSync: fullSync,
      sourceColor: sourceColor || 'default',
      destinationColor: destColor || 'default', // Use destinationColor key for SyncItem prop
      tag: fixLabel || 'default', // Use tag key for SyncItem prop
      matchColors,
      hasFilters: hasFilters,
      syncLevel: syncLevel.join('|'),
      filterColor: filterColor || 'none',
      startCutOff: startCutOff,
      endCutOff: endCutOff,
      excludeInvites: excludeInvites,
      status: 'synced', // Assume synced for preview
      active: true, // Assume active for preview
      // Add other props SyncItem might expect, like email (if needed for preview)
      sourceEmail: sourceCal.email,
      destEmail: destCal.email,
    };
    console.log(item)
    return item;
  }

  nextPage = () => {
    const { page, lastPage, farthestPage, sync } = this.state;
    if (page > farthestPage) {
      this.setState({ farthestPage: page });
    }
    // Skip options page if destination is read-only (ICS/Caldav)
    const skipOptionsPage = sync.destination?.calendarAccountType === 'ics' || sync.destination?.calendarAccountType === 'caldav';
    
    if (page === lastPage || (page === lastPage - 1 && skipOptionsPage)) {
      this.setState({ showModal: true, isLoading: false });
      return;
    } else {
      const nextPage = page + 1; // Skip page 1 if needed
      this.setState(
        { page: nextPage },
        () => { window.scrollTo(0, 0) }
      );
    }
  }

  changePage = (page) => {
    const { farthestPage, sync } = this.state;
     // Prevent going back to options page if it should be skipped
    //  if (page === 1 && (sync.destination?.calendarAccountType === 'ics' || sync.destination?.calendarAccountType === 'caldav')) {
    //     return; // Do nothing if trying to go to page 1 when it should be skipped
    // }
    if (page > farthestPage) {
      this.setState({ farthestPage: page });
    }
    this.setState({ page });
  }

  checkFilters = () => {
    const { sync } = this.state;
    if (!sync.source) return false; // Cannot check filters without source

    let hasChanged = false;
    if (sync.source.calendarAccountType === 'ms') {
      if (!sync.syncLevel.includes('free') || !sync.syncLevel.includes('tentative')) {
        hasChanged = true;
      }
    } else if (!sync.syncLevel.includes('free')) {
      hasChanged = true;
    }

    if (sync.excludeInvites) hasChanged = true;
    if (sync.filterColor !== 'none') hasChanged = true;
    if (sync.startCutOff !== -1) hasChanged = true;
    if (sync.endCutOff !== -1) hasChanged = true;

    return hasChanged;
  }

  changeSyncValue = (field, value) => {
    // console.log(field, value)
    var changeSourceColor = false
    var changeDestColor = false
    var filterChange = false
    if (
      field == 'syncLevel' ||
      field == 'filterColor' ||
      field == 'startCutOff' ||
      field == 'endCutOff' ||
      field == 'excludeInvites'
    ) {
      filterChange = true
    }
    if (field == 'source') {
      changeSourceColor = true
    }
    if (field == 'destination') {
      changeDestColor = true
    }
    if (field == 'clearTag') {
      this.setState({
        sync: {
          ...this.state.sync,
          includeSubject: this.state.sync.includeSubject,
          includeTag: this.state.sync.label != ' ',
          toggle: value,
        },
      })
      return
    }
    if (field == 'includeSubject') {
      this.setState({
        sync: {
          ...this.state.sync,
          includeSubject: value,
          includeTag: !value && this.state.sync.label != ' ',
        },
      })
      return
    }
    if (field == 'includeTag') {
      this.setState({
        sync: {
          ...this.state.sync,
          includeSubject: this.state.sync.includeSubject,
          includeTag: value,
        },
      })
      return
    }
    this.setState(
      {
        sync: {
          ...this.state.sync,
          [field]: value,
        },
      },
      () => {
        // console.log("CHANGE " + field)
        // console.log(this.state.schedule)
        if (field == 'label') {
          if (value == ' ') {
            this.changeSyncValue('includeTag', false)
          } else if (value != '') {
            this.changeSyncValue('includeTag', true)
          }
        }
        if (changeSourceColor) {
          this.changeSyncValue('sourceColor', 'default')
          if (value == null) {
            this.changeSyncValue('destination', null)
          }
        }
        if (changeDestColor) {
          this.changeSyncValue('destColor', 'default')
        }
        if (filterChange) {
          this.changeSyncValue('hasFilters', this.checkFilters())
        }
      }
    )
    
  }


  getAccountInfo = (c) => {
    if (!c || !this.props.accounts) return null; // Guard against missing data

    const account = this.props.accounts.find(
      (a) => a.calendarAccountId === c.calendarAccountId
    );
    if (!account) return <span className="text-xs text-red-500">{c.id} (Account missing)</span>; // Handle missing account

    let prepend = '';
    if (
      c.calendarAccountType == 'google' &&
      c.id != account.email &&
      !c.id.endsWith('calendar.google.com')
    ) {
      prepend = `${c.id}`;
    }

    return (
      <>
        {prepend != '' && (
          <>
            from: <u>{prepend}</u> shared to:{' '}
          </>
        )}
        {account.email}
        {(c.name === 'Calendar' && c.owner?.address === account.email) || c.id === account.email ? (
          <span className="block text-xs text-gray-500">Primary Calendar</span>
        ) : ''}
        <div className="flex mt-1">
          {!c.canEdit && (
            <CBTag color="red" className="text-xs">Read Only</CBTag>
          )}
          {c.id.endsWith('import.calendar.google.com') && (
             <CBTag color="blue" className="text-xs">Imported</CBTag>
          )}
        </div>
      </>
    )
  }
  SourceForm = () => {
    const { t, accounts, navigate } = this.props; // Use props directly
    const { allCalendars, sync, showICS, ics_link, ics_error, sourceCalendarTimezone } = this.state;
    const timezoneOptions = this.getOptions(); // Get options for select

    return (
      <>
        <div style={{ marginBottom: 40 }}>
          <CBHeader
            step={1}
            label={t('sync.select_calendars')}
            buttonLabel={t('sync.cancel_sync')}
            buttonIcon={<Close />}
            buttonAction={(e) => navigate('/dashboard/syncs/')}
          />
          {accounts.length === 0 && (
              <center className="mt-8 mb-8 text-lg">
                <a onClick={() => navigate('/dashboard/accounts/new')} className="text-blue-600 hover:underline">
                  {t('sync.add_calendar_account')}
                </a>
              </center>
            )}
          {this.state.destLabel && this.state.sourceLabel && ( // Check both labels
            <div className="text-sarabun text-lg mb-4"> {/* Added margin */}
              {t('sync.selected_source_calendar')} <br/> {/* Use br for line break */}
              <b>{this.state.sourceLabel}</b>
            </div>
          )}
          {/* Show selection only if source is not set or editing */}
          {(!this.state.sourceLabel || !this.props.id) && allCalendars.length > 0 && (
              <>
                <CBHeader
                  icon={<CalendarIcon />}
                  label={t('sync.select_source_calendar')}
                  subheader={true} // Make it a subheader
                />
                <div className="mb-4">{t('sync.select_source_description')}</div>

                {(sync.source == null || sync.source.calendarAccountType != 'ics') && (
                  <CBRadioGroupBigCalendar
                    title=""
                    style={{ width: '100%', marginTop: 8, marginBottom: 8 }}
                    values={allCalendars}
                    selected={sync.source}
                    labels={allCalendars.map(c => c.name || c.summary)}
                    icons={reduce(allCalendars, (acc, calendar) => {
                        const Component = calendar.calendarAccountType === 'google' ? <GoogleLogo className="mr-2 w-6 h-6" /> :
                                          calendar.calendarAccountType === 'ms' ? <FontAwesomeIcon className="mr-2" icon={faOutlook} size="lg" style={{ width: 24, height: 24 }} color={colorOutlook} /> :
                                          <FontAwesomeIcon className="mr-2" icon={faApple} size="lg" style={{ width: 24, height: 24 }} color={colorApple} />;
                        return set(acc, [calendar.id], Component);
                      }, {})}
                    subLabels={reduce(allCalendars, (acc, calendar) => set(acc, [calendar.id], this.getAccountInfo(calendar)), {})}
                    selectedComponent={
                      <>
                        <div className="mt-2 mb-2 text-sm">{t('sync.calendar_timezone')}</div>
                        {sync.source?.calendarAccountType === 'google' && (
                            <div className="ml-2 p-1 border-b-2 border-neutral_2 font-sarabun font-semibold text-sm"> {/* Adjusted styling */}
                              {sync.source.timeZone}
                            </div>
                          )}
                        {sync.source && sync.source.calendarAccountType !== 'google' && (
                            <CBSelect
                              showSearch // CBSelect might not support this, filtering happens in browser dropdown
                              size="small" // Control size via className if needed
                              style={{ width: '100%', margin: '0px 0px 20px 0px' }}
                              placeholder={t('sync.select_timezone_placeholder')}
                              labels={timezoneOptions.map(opt => opt.label)}
                              values={timezoneOptions.map(opt => opt.value)}
                              selected={sourceCalendarTimezone}
                              onChange={(e) => this.setState({ sourceCalendarTimezone: e })}
                            />
                          )}
                      </>
                    }
                    onChange={(calendar) => {
                      this.changeSyncValue('source', calendar)
                      window.scrollTo(0, 0)
                    }}
                  />
                )}

                {sync.source?.calendarAccountType === 'ics' && (
                    <div className="bg-gray-100 p-4 border border-gray-300 rounded mb-4">
                      <div className="flex flex-row justify-between items-start">
                        <div className="flex-grow mr-4">
                          <div className="text-sm font-medium break-all">{sync.source.id}</div>
                          <div className="text-xs mt-2">{t('sync.calendar_timezone')}</div>
                          <div>
                             <CBSelect
                              showSearch
                              size="small"
                              style={{ width: '100%', marginTop: '4px', marginBottom: '10px' }}
                              placeholder={t('sync.select_timezone_placeholder')}
                              labels={timezoneOptions.map(opt => opt.label)}
                              values={timezoneOptions.map(opt => opt.value)}
                              selected={sourceCalendarTimezone}
                              onChange={(e) => this.setState({ sourceCalendarTimezone: e })}
                            />
                          </div>
                          <div className="mt-1">
                            <CBTag color="red">{t('sync.read_only')}</CBTag>
                          </div>
                        </div>
                        <button onClick={() => this.changeSyncValue('source', null)} className="text-gray-500 hover:text-red-600">
                          <Close className="w-5 h-5"/>
                        </button>
                      </div>
                    </div>
                  )}

                {!sync.source && (
                  <div
                    className="flex flex-row items-center gap-2 mt-2 font-manrope text-sm text-gray-600 mb-2 cursor-pointer hover:text-blue-600"
                    onClick={() => this.setState({ showICS: !showICS })}
                  >
                    {showICS ? ( /* Chevron Down */
                      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-4 h-4">
                        <path strokeLinecap="round" strokeLinejoin="round" d="M19.5 8.25l-7.5 7.5-7.5-7.5" />
                      </svg>
                    ) : ( /* Chevron Right */
                      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-4 h-4">
                        <path strokeLinecap="round" strokeLinejoin="round" d="M8.25 4.5l7.5 7.5-7.5 7.5" />
                      </svg>
                    )}
                    {t('sync.other_calendar_types')}
                  </div>
                )}

                {showICS && !sync.source && (
                  <div className="flex flex-col gap-2 ml-8 pl-2 border-l-2 border-gray-200">
                    <CBInput
                      hint="https://..."
                      error={ics_error}
                      onChange={(e) => this.setState({ ics_link: e, ics_error: null })} // Clear error on change
                      value={ics_link}
                      placeholder="https://..."
                    />
                    <div className="mb-4 flex flex-col sm:flex-row sm:items-center gap-2">
                      <CBButton
                        onClick={() => {
                          if(!ics_link.startsWith("http")) {
                            const webcalMsg = ics_link.startsWith("webcal") ? ` ${t('sync.webcal_replace')}` : '';
                            this.setState({ics_error: t('sync.ics_url_error', { webcal: webcalMsg })})
                          } else {
                            this.changeSyncValue('source', {
                              id: ics_link,
                              calendarAccountId: ics_link, // Use link as account ID for ICS
                              calendarAccountType: 'ics',
                              name: 'ICS URL', // Or derive from URL?
                              summary: 'ICS URL',
                              canEdit: false,
                              email: 'N/A' // Add placeholder email
                            });
                            this.setState({ ics_link: '', ics_error: null, showICS: false });
                          }
                        }}
                        disabled={!ics_link.trim()} // Disable if empty
                      >
                        {t('sync.use_ics_url')}
                      </CBButton>
                      <a className="text-sm text-blue-600 hover:underline"
                         target="_blank"
                         rel="noopener noreferrer"
                         href="https://help.calendarbridge.com/uncategorized/how-to-get-an-ics-url-for-you-calendar/"
                      >
                        {t('sync.how_to_access_ics')}
                      </a>
                    </div>
                  </div>
                )}

                {sync.source == null && (
                  <p className="text-sm text-gray-600 mt-2"> {/* Replaced Text */}
                    {t('sync.calendar_not_showing')}{' '}
                    <Link to="/dashboard/accounts/new" className="text-blue-600 hover:underline">
                      {t('sync.add_another_account_link')}
                    </Link>
                    .
                  </p>
                )}
              </>
            )}
          {/* Render DestinationForm only if source is selected */}
          {sync.source != null && this.DestinationForm()}
        </div>
      </>
    )
  }

  DestinationForm = () => {
    const { t, accounts, navigate } = this.props;
    const { allCalendars, sync, destCalendarTimezone } = this.state;
    const timezoneOptions = this.getOptions();

    // filter out the read only calendars and the source calendar
    const destinationCalendars = reduce(
      allCalendars,
      (acc, calendar) => {
        // Ensure sync.source exists before accessing its id
        if (calendar.canEdit && sync.source && calendar.id !== sync.source.id) {
          return [...acc, calendar]
        }
        return acc
      },
      []
    )

    return (
      <>
        <div className="mb-10 mt-10">
          {this.state.destLabel && !this.props.id && ( // Show selected only if not editing
            <div className="text-sarabun text-lg mb-4">
              {t('sync.selected_destination_calendar')} <br/>
              <b>{this.state.destLabel}</b>
            </div>
          )}
          {/* Show selection only if destination not set or editing */}
          {(!this.state.destLabel || !this.props.id) && (
            <>
              <CBHeader
                icon={<CalendarIcon />}
                label={t('sync.select_destination_calendar')}
                subheader={true} // Make it a subheader
              />
              <div className="mb-4">{t('sync.select_destination_description')}</div>
              <CBRadioGroupBigCalendar
                title=""
                style={{ width: '100%', marginTop: 8, marginBottom: 8 }}
                values={destinationCalendars}
                selected={sync.destination}
                labels={destinationCalendars.map((c) => c.name || c.summary)}
                icons={reduce(destinationCalendars, (acc, calendar) => {
                    const Component = calendar.calendarAccountType === 'google' ? <GoogleLogo className="mr-2 w-6 h-6" /> :
                                      calendar.calendarAccountType !== 'ms' ? <FontAwesomeIcon className="mr-2" icon={faApple} size="lg" style={{ width: 24, height: 24 }} color={colorApple} /> :
                                      <FontAwesomeIcon className="mr-2" icon={faOutlook} size="lg" style={{ width: 24, height: 24 }} color={colorOutlook} />;
                    return set(acc, [calendar.id], Component);
                  }, {})}
                subLabels={reduce(destinationCalendars, (acc, calendar) => set(acc, [calendar.id], this.getAccountInfo(calendar)), {})}
                onChange={(calendar) => {
                  this.changeSyncValue('destination', calendar)
                  window.scrollTo(0, 0)
                }}
                selectedComponent={
                  <>
                    <div className="mt-2 mb-2 text-sm">{t('sync.calendar_timezone')}</div>
                    {sync.destination?.calendarAccountType === 'google' && (
                        <div className="ml-2 p-1 border-b-2 border-neutral_2 font-sarabun font-semibold text-sm">
                          {sync.destination.timeZone}
                        </div>
                      )}
                    {sync.destination && sync.destination.calendarAccountType !== 'google' && (
                        <CBSelect
                          showSearch
                          size="small"
                          style={{ width: '100%', margin: '0px 0px 20px 0px' }}
                          placeholder={t('sync.select_timezone_placeholder')}
                          labels={timezoneOptions.map(opt => opt.label)}
                          values={timezoneOptions.map(opt => opt.value)}
                          selected={destCalendarTimezone}
                          onChange={(e) => this.setState({ destCalendarTimezone: e })}
                        />
                      )}
                  </>
                }
              />
              {sync.destination == null && (
                <p className="text-sm text-gray-600 mt-2"> {/* Replaced Text */}
                  {t('sync.calendar_not_showing')}{' '}
                  <Link to="/dashboard/accounts/new" className="text-blue-600 hover:underline">{t('sync.add_another_account_link')}</Link>.
                </p>
              )}
            </>
          )}
        </div>
      </>
    )
  }

  // getColorOptions remains largely the same, just replace Select.Option with objects
   getColorOptions = () => {
    const { t } = this.props;
    const noneOption = { value: 'none', label: t('sync.none') };
    const msOptions = [
      { value: "Green category", label: <div className="flex items-center"><div className="w-3 h-3 rounded-full mr-2" style={{ background: '#00ff00' }} /> Green category</div> },
      { value: "Yellow category", label: <div className="flex items-center"><div className="w-3 h-3 rounded-full mr-2 bg-yellow-200" /> Yellow category</div> },
      { value: "Red category", label: <div className="flex items-center"><div className="w-3 h-3 rounded-full mr-2 bg-red-500" /> Red category</div> },
      { value: "Orange category", label: <div className="flex items-center"><div className="w-3 h-3 rounded-full mr-2" style={{ background: 'orange' }} /> Orange category</div> },
      { value: "Blue category", label: <div className="flex items-center"><div className="w-3 h-3 rounded-full mr-2" style={{ background: 'blue' }} /> Blue category</div> },
      { value: "Purple category", label: <div className="flex items-center"><div className="w-3 h-3 rounded-full mr-2" style={{ background: 'purple' }} /> Purple category</div> },
    ];
    const googleOptions = [
       { value: "11", label: <div className="flex items-center"><div className="w-3 h-3 rounded-full mr-2" style={{ background: '#D50000' }} /> Tomato</div> },
       { value: "10", label: <div className="flex items-center"><div className="w-3 h-3 rounded-full mr-2" style={{ background: '#0B8043' }} /> Basil</div> },
       { value: "9", label: <div className="flex items-center"><div className="w-3 h-3 rounded-full mr-2" style={{ background: '#3F51B5' }} /> Blueberry</div> },
       // Add other Google colors as needed
    ];

    // Check source type safely
    if (this.state.sync?.source?.calendarAccountType === 'ms') {
      return [noneOption, ...msOptions];
    } else {
      // Default to Google colors if source is not MS or not set yet
      return [noneOption, ...googleOptions];
    }
  }


  EventDetailForm = () => {
    const { t, license } = this.props;
    const { sync } = this.state;
    const colorOptions = this.getColorOptions(); // Get options for select

    return (
      <>
        <CBHeader
          step={2} // Adjusted step number
          label={t('sync.select_information_sync')}
          buttonLabel={t('sync.edit_previous_step')}
          buttonIcon={<Up />}
          buttonAction={(e) => {
            this.setState({ page: this.state.page - 1 })
          }}
        />

        <div className="p-4">
          <div className="font-sarabun mt-6 mb-6 text-sm"> {/* Adjusted size */}
            {t('sync.select_info_description')}
            {license.policy != 'all' && (
              <div className="text-red-600 mt-1">{t('sync.admin_limited_sync')}</div>
            )}
          </div>

          {(license.policy == 'all' || license.policy.includes('subject')) && (
              <div className="mb-3">
                <CBCheckItem
                  label={t('sync.field_subject')}
                  box={true}
                  border={true}
                  color={"#FF6709"}
                  checked={sync.includeSubject}
                  onChange={(e) => { this.changeSyncValue('includeSubject', e) }}
                />
              </div>
            )}
          <div>
            {(license.policy == 'all' || license.policy.includes('contact')) && (
              <>
                <CBCheckItem
                  label={t('sync.field_attendees')}
                  box={true}
                  color={"#FF6709"}
                  checked={sync.includeAttendees}
                  onChange={(e) => { this.changeSyncValue('includeAttendees', e) }}
                />
                <div className="font-sarabun p-2 bg-neutral_1 mb-3 text-neutral_3 text-xs"> {/* Adjusted size */}
                  {t('sync.attendees_description')}
                </div>
              </>
            )}
          </div>
          {(license.policy == 'all' || license.policy.includes('description')) && (
            <div className="mb-3">
              <CBCheckItem
                label={t('sync.field_description')}
                color={"#FF6709"}
                box={true}
                checked={sync.includeDescription}
                onChange={(e) => { this.changeSyncValue('includeDescription', e) }}
              />
            </div>
          )}
          {(license.policy == 'all' || license.policy.includes('location')) && (
            <div className="mb-3">
              <CBCheckItem
                label={t('sync.field_location')}
                box={true}
                color={"#FF6709"}
                checked={sync.includeLocation}
                onChange={(e) => { this.changeSyncValue('includeLocation', e) }}
              />
            </div>
          )}
          {(license.policy == 'all' || license.policy.includes('meeting')) && (
            <div className="mb-3">
              <CBCheckItem
                label={t('sync.field_conference')}
                box={true}
                color={"#FF6709"}
                checked={sync.includeMeeting}
                onChange={(e) => { this.changeSyncValue('includeMeeting', e) }}
              />
            </div>
          )}

          {(license.policy == 'all' || license.policy.includes('reminder')) && (
            <div>
              <CBCheckItem
                label={t('sync.field_reminders')}
                box={true}
                color={"#FF6709"}
                checked={sync.includeReminders}
                onChange={(e) => { this.changeSyncValue('includeReminders', e) }}
              />
              <div className="font-sarabun p-2 bg-neutral_1 mb-3 text-neutral_3 text-xs"> {/* Adjusted size */}
                {t('sync.reminders_description')}
              </div>
            </div>
          )}
          {(license.policy == 'all' || license.policy.includes('private')) && (
            <>
              <CBCheckItem
                label={t('sync.field_all_private')}
                box={true}
                color={"#FF6709"}
                checked={sync.allPrivate}
                onChange={(e) => { this.changeSyncValue('allPrivate', e) }}
              />
              <div className="font-sarabun p-2 bg-neutral_1 text-neutral_3 text-xs"> {/* Adjusted size */}
                {t('sync.private_description')}
              </div>
            </>
          )}
        </div>
        <div className="p-4 mb-4">
            <div className=" mb-8 p-4 flex flex-col sm:flex-row gap-4 justify-between border-neutral items-start border-2 rounded"> {/* Use flex for layout */}
              <div className="text-lg font-manrope mb-2 sm:mb-0">{t('sync.tag')}</div>
              <div className="flex-grow sm:max-w-xs"> {/* Control width */}
                <CBInput
                  disabled={sync.label == ' '}
                  value={sync.label === ' ' ? '' : sync.label} // Show empty if space
                  hint="(copy)"
                  onChange={(e) => { this.changeSyncValue('label', e) }}
                />
                <CBCheckItem
                  label={<>{t('sync.no_tag')}</>}

                  onChange={(e) => {
                    console.log("NO TAG")
                    console.log(e)
                    this.changeSyncValue('label', e ? ' ' : '(copy)')
                  }}
                  checked={sync.label == ' '}
                  className="mt-1"
                />
              </div>
            </div>
            {sync && this.renderPreview()}
          </div>
      </>
    )
  }

  // DirectionForm is removed

  getEventTitle = () => {
    const { t } = this.props;
    const { sync } = this.state;
    const labelPart = sync.label === ' ' ? '' : sync.label;

    if (!sync.includeSubject) {
      // Simplified logic based on 'free' exclusion
      if (sync.hasFilters && !sync.syncLevel.includes('free')) {
         return `${t('sync.preview_busy')} ${labelPart}`.trim();
      } else {
         return `${t('sync.preview_free_busy')} ${labelPart}`.trim();
      }
    }
    return `${t('sync.preview_your_event_subject')} ${labelPart}`.trim();
  }

  getColor = (color) => {
    // This function maps color names/IDs to hex codes for styling
    // Keep this logic as it's used for inline styles in preview
    switch (color) {
      case 'Green category': return '#008000';
      case 'Red category': return '#ff0000';
      case 'Yellow category': return '#ffff00';
      case 'Blue category': return '#0000ff';
      case 'Purple category': return '#800080';
      case 'Orange category': return '#ffa500';
      case '1': return '#a4bdfc'; // Lavender
      case '2': return '#7ae7bf'; // Sage
      case '3': return '#dbadff'; // Grape
      case '4': return '#ff887c'; // Flamingo
      case '5': return '#fbd75b'; // Banana
      case '6': return '#ffb878'; // Tangerine
      case '7': return '#46d6db'; // Peacock
      case '8': return '#e1e1e1'; // Graphite
      case '9': return '#5484ed'; // Blueberry
      case '10': return '#51b749'; // Basil
      case '11': return '#D50000'; // Tomato
      default: return '#eee'; // Default fallback color
    }
  }

  renderPreview = () => {
     const { t } = this.props;
     const { sync } = this.state;
     if (!sync.source || !sync.destination) return null; // Need calendars for preview

    return (
      <div className="flex flex-col gap-y-4 border p-2 border-neutral_1 mt-4 items-center mb-4 rounded">
        <div className="text-lg font-manrope">{t('sync.subject_line_preview')}</div>
        <div className="grid lg:grid-cols-2 lg:gap-2 gap-4 grid-rows-1 w-full max-w-xl"> {/* Control width */}
          {/* Source Preview */}
          <div className="flex flex-col items-center">
            <div className="text-lg mb-1">{t('sync.source')}</div>
            <div className="w-full">
              <div className="flex flex-col gap-y-1 bg-blue-100 p-2 rounded-md pl-3 text-sm"> {/* Example source color */}
                <div>{t('sync.preview_your_event_subject')}</div>
                {/* Simplified preview content */}
              </div>
            </div>
          </div>
          {/* Destination Preview */}
          <div className="flex flex-col items-center">
            <div className="text-lg mb-1">{t('sync.destination')}</div>
            <div className="w-full">
               {/* Apply destination color if not default */}
               <div
                 className={`flex flex-col gap-y-1 p-2 rounded-md pl-3 text-sm ${sync.destColor === 'default' ? 'bg-gray-200' : ''}`}
                 style={sync.destColor !== 'default' ? { backgroundColor: this.getColor(sync.destColor) || '#eee' } : {}} // Apply dynamic color
               >
                <div>{this.getEventTitle()}</div>
                {/* Simplified preview content based on selections */}
                {sync.includeDescription && <div className="text-xs text-gray-600">Description...</div>}
                {sync.includeLocation && <div className="text-xs text-gray-600">Location...</div>}
                {/* Add other fields based on sync state */}
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }


  getButtonLabelByStep() {
    const { t, id } = this.props; // Use props directly
    const { page, lastPage, sync } = this.state;
    const skipOptionsPage = sync.destination?.calendarAccountType === 'ics' || sync.destination?.calendarAccountType === 'caldav';
    const currentLastPage = skipOptionsPage ? lastPage - 1 : lastPage; // Adjusted last page index

    switch (page) {
      case 0:
        return t('sync.continue_to_privacy');
      case 1:
        // If options page is skipped, this becomes the last step
        return skipOptionsPage ? (id ? t('sync.update_sync_button') : t('sync.create_sync_button')) : t('sync.continue_to_options'); // This case (page 1) is now the options page if not skipped
      case 2: // This is now the review/submit step if options weren't skipped
        return id ? t('sync.update_sync_button') : t('sync.create_sync_button');
      default:
        return t('common.continue');
    }
  }

  DirectionForm = () => {
    const source = this.state.sync.source
    const target = this.state.sync.destination
    // The preview object seems unused in the provided code, omitting for brevity unless needed later.
    // const preview = { ... }

    return (
      <>
        <CBHeader
          step={3}
          label={this.props.t('sync.configure_sync_options')}
          buttonLabel={this.props.t('sync.edit_previous_step')}
          buttonIcon={<Up></Up>}
          buttonAction={(e) => {
            this.setState({ page: this.state.page - 1 })
          }}
        ></CBHeader>
        <div className="pl-4 pr-4 mt-6 mb-6">
          {this.props.t('sync.color_tag_options')} {/* Localized */}
        </div>
        {/* <Row type="flex" justify="center">
          {!source.canEdit && (
            <Alert
              style={{ marginTop: 40 }}
              message="The source calendar is read-only so you can only sync in one direction."
              type="warning"
            />
          )}
          <Radio.Group
            defaultValue={this.state.sync.bidirection}
            onChange={(e) =>
              this.changeSyncValue('bidirection', e.target.value)
            }
            value={this.state.sync.bidirection}
            disabled={!source.canEdit}
            size="large"
            style={{ padding: 40 }}
          >
            <Radio.Button
              value={true}
              style={{
                padding: 20,
                fontSize: '2em',
                height: 80,
                lineHeight: '38px',
              }}
            >
              <>
                <FontAwesomeIcon
                  icon={faExchangeAlt}
                  size="1x"
                  style={{ marginRight: 10 }}
                />
                Both Directions
              </>
            </Radio.Button>
            <Radio.Button
              value={false}
              style={{
                padding: 20,
                fontSize: '2em',
                height: 80,
                lineHeight: '38px',
              }}
            >
              <>
                <FontAwesomeIcon
                  icon={faLongArrowAltRight}
                  size="1x"
                  style={{ marginRight: 10 }}
                />
                One Direction
              </>
            </Radio.Button>
          </Radio.Group>
        </Row> */}

        <div className="pl-4 pr-4 pb-4 border-2 border-neutral_1 rounded-sm">
          <CBHeader
            icon={<CalendarIcon></CalendarIcon>}
            label={`${this.props.t('sync.destination')}: ${
              this.state.sync.destination.name ||
              this.state.sync.destination.summary
            }  (${this.state.sync.destination.email})`}
            subheader={true}
          ></CBHeader>

          <div className="border-2 border-neutral_1 rounded-sm hover:border-neutral_2 pt-3 pb-1 pl-2 pr-2 lg:pl-4 lg:pr-4 space-x-3 items-center cursor-pointer w-full">
            <div className="font-manrope text-neutral_4 mb-2">
              {this.props.t('sync.default_copy_color')} {/* Localized */}
            </div>
            <CBColorPicker
              key={`dest-${this.state.sync.destination.id}-${this.state.sync.destination.calendarAccountType}`}
              type={this.state.sync.destination.calendarAccountType}
              onColorChangeCallback={(color) => {
                console.log(color)
                this.changeSyncValue('destColor', color)
              }}
              color={this.state.sync.destColor}
            ></CBColorPicker>
          </div>
          {!this.state.sync.bidirection && // Corrected typo: bidirection
            this.state.sync.destination.calendarAccountType ==
              this.state.sync.source.calendarAccountType && (
              <div className="mt-4">
                <CBCheckItem
                  onChange={(e) => {
                    this.changeSyncValue('matchColors', e)
                  }}
                  checked={this.state.sync.matchColors}
                  label={this.props.t('sync.match_source_colors')}
                ></CBCheckItem>
              </div>
            )}
        </div>
        {this.state.sync.source.calendarAccountType != 'ics' &&
          this.state.sync.source.calendarAccountType != 'caldav' &&
          this.state.sync.destination.calendarAccountType != 'caldav' && (
            <div
              className="flex flex-row items-center gap-2 mt-2 font-manrope text-xl text-neutral_4 mb-2 cursor-pointer"
              onClick={(e) => {
                this.setState({ showAdvanced: !this.state.showAdvanced })
              }}
            >
              {/* {this.state.showAdvanced ? ( <svg>...</svg> ) : ( <svg>...</svg> )} */}
              {this.props.t('sync.advanced')} {/* Localized */}
            </div>
          )}
        {this.state.sync.source.calendarAccountType != 'ics' &&
          this.state.sync.source.calendarAccountType != 'caldav' &&
          this.state.sync.destination.calendarAccountType != 'caldav' &&
          this.state.showAdvanced && (
            <div className="p-4 border mb-4">
              <div className="text-xl mb-2 mt-2">{this.props.t('sync.filtering')}</div> {/* Localized */}
              <div className="flex flex-col gap-2">
                <CBCheckItem
                  onChange={(e) => {
                    if (e) {
                      if (
                        this.state.sync.source.calendarAccountType == 'google'
                      ) {
                        this.changeSyncValue('syncLevel', ['busy'])
                      } else {
                        this.changeSyncValue(
                          'syncLevel',
                          this.state.sync.syncLevel.filter((it) => it != 'free')
                        )
                      }
                    } else {
                      if (
                        this.state.sync.source.calendarAccountType == 'google'
                      ) {
                        this.changeSyncValue('syncLevel', ['free', 'busy'])
                      } else {
                        this.changeSyncValue('syncLevel', [
                          'free',
                          ...this.state.sync.syncLevel,
                        ])
                      }
                    }
                  }}
                  checked={!this.state.sync.syncLevel.includes('free')}
                  label={this.props.t('sync.exclude_free_events')}
                ></CBCheckItem>
                {this.state.sync.source.calendarAccountType == 'ms' && (
                  <CBCheckItem
                    onChange={(e) => {
                      if (e) {
                        // Simplified logic based on original structure
                        this.changeSyncValue(
                          'syncLevel',
                          this.state.sync.syncLevel.filter(
                            (it) => it != 'tentative'
                          )
                        )
                      } else {
                        this.changeSyncValue('syncLevel', [
                          'tentative',
                          ...this.state.sync.syncLevel,
                        ])
                      }
                    }}
                    checked={!this.state.sync.syncLevel.includes('tentative')}
                    label={this.props.t('sync.exclude_tentative_events')}
                  ></CBCheckItem>
                )}
                {this.state.sync.source.calendarAccountType == 'google' && (
                  <CBCheckItem
                    onChange={(e) => {
                      this.changeSyncValue('excludeInvites', e)
                    }}
                    checked={this.state.sync.excludeInvites}
                    label={this.props.t('sync.exclude_unaccepted_invites')}
                  ></CBCheckItem>
                )}
              </div>
              <div className="mt-4 flex flex-row items-center gap-4">
                <div className="text-base mt-2 mb-1 font-manrope font-sm pl-2">
                  {this.props.t('sync.exclude_source_events_color')} {/* Localized */}
                </div>
                {/* Replaced Ant Design Select with CBSelect */}
                <CBSelect
                  style={{
                    width: '200px',
                    margin: '10px 0px 0px 0px',
                  }}
                  // Prepare labels/values from getColorOptions()
                  // Extracting text label from JSX for CBSelect
                  labels={[
                      this.props.t('sync.select_color_filter'), // Placeholder
                      // Extract text content from JSX label (assuming text is 2nd child)
                      // Handle the 'none' option which has a string label
                      ...this.getColorOptions().map(opt => typeof opt.label === 'string' ? opt.label : opt.label.props.children[1])
                  ]}
                  values={['none', ...this.getColorOptions().map(opt => opt.value)]} // Keep 'none' value consistent
                  selected={this.state.sync.filterColor}
                  onChange={(value) => { // CBSelect passes the value directly
                    this.changeSyncValue('filterColor', value)
                  }}
                />
                {/* <CBCheckItem ... Filter Color Checkbox ... ></CBCheckItem> */}
              </div>
              {/* <div className="flex flex-col gap-2 mt-4"> ... Time Range Filter ... </div> */}
            </div>
          )}
        {/* {this.renderPreview()} */}
        {this.props.id != null && this.state.sync.editBidirection && (
          <div className="mt-10 mb-10">
            <div className="mb-2 text-sarabun">{this.props.t('sync.direction_options')}</div> {/* Localized */}
            <CBCheckItem
              label={<>{this.props.t('sync.use_options_both_directions')}</>}
              checked={this.state.sync.bidirection}
              onChange={(e) => {
                this.changeSyncValue('bidirection', e)
              }}
            ></CBCheckItem>
          </div>
        )}
        {this.state.sync.bidirection && (
          <div
            className="pl-4 pr-4 pb-4 border-2 border-neutral_1 rounded-sm"
            style={{ marginBottom: 30, marginTop: 10 }}
          >
            <CBHeader
              icon={<CalendarIcon></CalendarIcon>}
              subheader={true}
              label={`${this.props.t('sync.destination')}: ${ // Changed from 'sync.destination' to 'sync.source' based on context
                this.state.sync.source.name || this.state.sync.source.summary
              } (${this.state.sync.source.email})`}
            ></CBHeader>

            {this.state.sync.bidirection && ( // This check seems redundant given the outer check
              <div>
                <div>{this.props.t('sync.copy_color')}</div> {/* Localized */}
                <CBColorPicker
                  key={`source-${this.state.sync.source.id}-${this.state.sync.source.calendarAccountType}`}
                  // sync={this.state.sync} // Prop 'sync' might not be needed by CBColorPicker
                  type={this.state.sync.source.calendarAccountType}
                  onColorChangeCallback={(color) => {
                    this.changeSyncValue('sourceColor', color)
                  }}
                  color={this.state.sync.sourceColor}
                ></CBColorPicker>
              </div>
            )}
          </div>
        )}
        {/* <Row> ... Debug UI Check ... </Row> */}
      </>
    )
  }
  render() {
    const { t, id } = this.props; // Use props directly
    const { page, lastPage, farthestPage, sync, allCalendars, isLoading, error, showModal } = this.state;

    const sourceCalendar = sync.source || { name: t('sync.not_selected'), incomplete: true };
    const destCalendar = sync.destination || { name: t('sync.not_selected'), incomplete: true };
    const skipOptionsPage = sync.destination?.calendarAccountType === 'ics' || sync.destination?.calendarAccountType === 'caldav';


    // Adjust pages array based on whether options step is skipped
    const pages = skipOptionsPage ? [this.SourceForm, this.EventDetailForm] : [this.SourceForm, this.EventDetailForm, this.DirectionForm]; // DirectionForm removed, EventDetailForm is page 1
    const currentLastPage = skipOptionsPage ? 1 : 2; // Adjust last page index (0-based)

    const CurrentPageForm = pages[page];

    return (
      // Replaced Layout with div
      <div className="flex flex-col md:flex-row">
        <SEO title={id ? t('sync.edit_sync_title') : t('sync.create_sync_title')} />
        {/* Replaced Content with main */}
        <main className="cb-content-frame bg-white flex-grow">
          <div className="cb-content-pane mobile_padding min-h-screen">
            <MediaQuery maxDeviceWidth={1224}>
              <CBSteps
                page={page}
                mobile={true}
                onPageChanged={this.changePage}
                className="mb-4" // Add margin
              >
                 <CBStep
                  primary={t('sync.step1_primary')}
                  secondary={
                    <div>
                      <div>{t('sync.source')}: {sync.source ? (sourceCalendar.name || sourceCalendar.summary) : t('sync.not_selected')}</div>
                      <div>{t('sync.destination')}: {sync.destination ? (destCalendar.name || destCalendar.summary) : t('sync.not_selected')}</div>
                    </div>
                  }
                />
                 <CBStep
                  primary={t('sync.step2_primary')}
                  secondary={page >= 1 ? syncTypeText(sync.includeSubject, sync.includeDescription, sync.includeLocation, sync.includeReminders, sync.allPrivate, sync.includeMeeting, sync.includeAttendees, sync.includeTag) : t('sync.not_selected')}
                  disabled={!sync.source || !sync.destination} // Disable if calendars not selected
                />
                {!skipOptionsPage && ( // Conditionally render options step
                    <CBStep
                      primary={t('sync.step3_primary')} // This is now step 3 conceptually
                      secondary={page >= 2 ? `${t('sync.tag')}: ${sync.label === ' ' ? t('sync.no_tag') : sync.label}` : t('sync.not_selected')}
                      disabled={page < 1 || !sync.source || !sync.destination} // Disable if previous steps not done
                    />
                )}
              </CBSteps>
            </MediaQuery>

            {CurrentPageForm && <CurrentPageForm />}

            {error && (
               <CBAlert variant="error" message={error} className="my-4" onClose={() => this.setState({ error: null })} />
            )}

            <SubmitButton
              type={'primary'}
              block
              badge={page === currentLastPage ? null : page + 2} // Adjust badge based on currentLastPage
              size="large"
              onClick={this.nextPage}
              loading={isLoading}
              disabled={
                (page === 0 && (!sync.source || !sync.destination)) ||
                isLoading
              }
              className="mt-8" // Add margin
            >
              {this.getButtonLabelByStep()}
            </SubmitButton>

            <CBModal
              title={t('sync.review_sync')}
              visible={showModal}
              wide={true}  
              disabled={isLoading}
              positiveLabel={isLoading ? t('common.submitting') : (id ? t('sync.update_sync_button') : t('sync.create_sync_button'))}
              onPositiveClick={() => this.submitSync()}
              onCancelClick={() => this.setState({ isLoading: false, showModal: false })}
            >
              
              {showModal && (
                <SyncItem
                  preview={true}
                  item={this.buildSyncItemForPreview()}
                  // Pass necessary account names for preview
                  sourceAccountName={sync.source?.email || 'N/A'}
                  destAccountName={sync.destination?.email || 'N/A'}
                />
              )}
            </CBModal>

          </div>
        </main>
        <MediaQuery minDeviceWidth={1224}>
           {/* Replaced Sider with aside */}
          <aside className="w-full md:w-[400px] md:flex-shrink-0 bg-gray-50 border-l border-gray-200">
            <div className="p-8 sticky top-0"> {/* Adjusted padding and added sticky */}
              <div className="mb-4">
                <CBHeader label={id ? t('sync.edit_sync') : t('sync.create_sync')} icon={<NewSync className="w-6 h-6"/>} />
              </div>
              <CBSteps
                page={page}
                onPageChanged={this.changePage}
                direction="vertical" // Keep vertical for desktop
              >
                 <CBStep
                  primary={t('sync.step1_primary')}
                  secondary={
                    <div>
                      <div>{t('sync.source')}: {sync.source ? (sourceCalendar.name || sourceCalendar.summary) : t('sync.not_selected')}</div>
                      <div>{t('sync.destination')}: {sync.destination ? (destCalendar.name || destCalendar.summary) : t('sync.not_selected')}</div>
                    </div>
                  }
                />
                 <CBStep
                  primary={t('sync.step2_primary')}
                  secondary={page >= 1 ? syncTypeText(sync.includeSubject, sync.includeDescription, sync.includeLocation, sync.includeReminders, sync.allPrivate, sync.includeMeeting, sync.includeAttendees, sync.includeTag) : t('sync.not_selected')}
                  disabled={!sync.source || !sync.destination}
                />
                 {!skipOptionsPage && ( // Conditionally render options step
                    <CBStep
                      primary={t('sync.step3_primary')}
                      secondary={page >= 2 ? `${t('sync.tag')}: ${sync.label === ' ' ? t('sync.no_tag') : sync.label}` : t('sync.not_selected')}
                      disabled={page < 1 || !sync.source || !sync.destination}
                    />
                 )}
              </CBSteps>
            </div>
          </aside>
        </MediaQuery>
      </div>
    )
  }
}

const SyncCreatePageState = ({ id }) => {
  const navigate = useNavigate()
  const [accounts] = useGlobalState('accounts')
  const [license] = useGlobalState('license')
  const [syncs] = useGlobalState('syncs')
  const { t } = useLocalization()
  return (
    <SyncCreatePage
      id={id}
      accounts={accounts || []} // Ensure arrays/objects exist
      license={license || {}}
      syncs={syncs || []}
      navigate={navigate}
      t={t}
    />
  )
}

export default SyncCreatePageState;
